export type MealConsumptionStatus = "eaten" | "uneaten";

export function kstDateTimeParts(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? "";
  return {
    date: `${value("year")}-${value("month")}-${value("day")}`,
    hour: Number(value("hour")),
    minute: Number(value("minute")),
  };
}

export function kstToday(now = new Date()) {
  return kstDateTimeParts(now).date;
}

export function canReportMealConsumption(mealDate: string, now = new Date()) {
  const current = kstDateTimeParts(now);
  if (mealDate < current.date) return true;
  return mealDate === current.date && current.hour >= 12;
}

export function isActualMealOrder(order: { menuName?: string; menu?: string; price?: number } | null | undefined) {
  if (!order) return false;
  const menuName = order.menuName ?? order.menu ?? "";
  if (menuName === "없음") return false;
  if (typeof order.price === "number" && order.price <= 0) return false;
  return true;
}

export function parseMealConsumptionStatus(value: unknown): MealConsumptionStatus | null {
  return value === "eaten" || value === "uneaten" ? value : null;
}

export function summarizeMealConsumption(orders: ReadonlyArray<{
  menu?: string;
  menuName?: string;
  price?: number;
  status?: string;
  consumptionStatus?: string | null;
}>) {
  let eligible = 0;
  let eaten = 0;
  let uneaten = 0;
  let unanswered = 0;
  for (const order of orders) {
    if (order.status === "vacation") continue;
    if (!isActualMealOrder(order)) continue;
    eligible += 1;
    if (order.consumptionStatus === "eaten") eaten += 1;
    else if (order.consumptionStatus === "uneaten") uneaten += 1;
    else unanswered += 1;
  }
  return { eligible, eaten, uneaten, unanswered };
}
